<template>
  <div>
    <SiteNavbar :username="username"/>
    <b-container id="main-container" fluid>
      <!-- Qui sono renderizzate le viste figlie della HomePage quali il menu principale ed i vari form -->
      <!-- In tal modo tutti possono condividere la navbar ed il footer -->
      <router-view/>
    </b-container>

    <b-navbar class="navbar bottom mt-3" :style="customer_styles.footer" >
      <b-navbar-nav align="center">
        <b-nav-text :style="customer_styles.footer_text" >{{footer_string}}</b-nav-text>
      </b-navbar-nav>
    </b-navbar>

  </div>
</template>

<script>
import moment from 'moment'
import SiteNavbar from '@/components/SiteNavbar.vue'
import { customerStylesMixin } from '@/mixins/customerStylesMixin'

export default {
  name: 'HomeBase',
  mixins: [ customerStylesMixin ],
  data () {
    return {
      // Nome utente da visualizzare nella navbar
      username : this.$store.getters.user_human_name
    }
  },
  computed : {
    /**
     * Torna la stringa del footer di modo tale che l'anno di "arrivo"
     * del Copyright è sempre aggiornato con l'anno attuale.
     */
    footer_string : function () {
      var m = moment();
      return 'Welfarebit © 2020 - ' + m.format( 'YYYY' ) + ' All rights reserved.';
    }
  },
  components: {
    SiteNavbar
  }
}
</script>

<style scoped>
/* Fa in modo che il container principale sia sempre alto almeno come l'86,8% del viewport
   anche quando non c'è contenuto ( non il 100% perchè è considerato lo spazio occupato
   dalla navbar superiore e dal footer ) in tal modo il footer è sempre posto in fondo
   alla pagina anche se il contenuto non la riempie tutta */
#main-container {
  min-height:86.8vh
}
</style>

